import { render, staticRenderFns } from "./ListPeople.vue?vue&type=template&id=2af205a4&"
import script from "./ListPeople.vue?vue&type=script&lang=js&"
export * from "./ListPeople.vue?vue&type=script&lang=js&"
import style0 from "./ListPeople.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports